import { 
  IonModal, 
  IonHeader, 
  IonToolbar, 
  IonTitle, 
  IonButtons, 
  IonButton, 
  IonIcon, 
  IonContent,
  IonBadge 
} from '@ionic/react';
import { close, documentText } from 'ionicons/icons';
import { TeamMember } from '../../types/teamSummary';
import { formatCertificationDate, getCertificationStatusColor, getCertificationStatusLabel } from '../../utils/certificationData';

interface CertificationsModalProps {
  member: TeamMember;
  isOpen: boolean;
  onClose: () => void;
}

export function CertificationsModal({ member, isOpen, onClose }: CertificationsModalProps) {
  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose}>
      <IonHeader>
        <IonToolbar>
          <IonTitle>{member.displayName}'s Certifications</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={onClose}>
              <IonIcon icon={close} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        {!member.certifications || member.certifications.length === 0 ? (
          <div className="py-8">
            <IonIcon icon={documentText} />
            <p>No certifications yet</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {member.certifications.map((cert) => (
              <div
                key={cert.id}
                className="flex justify-between gap-4"
              >
                <div className="flex-1">
                  <div className="flex justify-between">
                    <div>{cert.name}</div>
                    <IonBadge color={getCertificationStatusColor(cert.status)}>
                      {getCertificationStatusLabel(cert.status)}
                    </IonBadge>
                  </div>
                  <p>Issued by {cert.issuer}</p>
                  <div>
                    <p>
                      <span>Completed:</span> {formatCertificationDate(cert.completedDate)}
                    </p>
                    {cert.expiryDate && (
                      <p>
                        <span>Expires:</span> {formatCertificationDate(cert.expiryDate)}
                      </p>
                    )}
                    <p>
                      <span>Credential ID:</span> {cert.credentialId}
                    </p>
                  </div>
                </div>
                <IonIcon icon={documentText} />
              </div>
            ))}
          </div>
        )}
      </IonContent>
      <div className="px-4 py-3 border-t flex items-center justify-center">
        <IonButton
          onClick={onClose}
          color="primary"
        >
          Close
        </IonButton>
      </div>
    </IonModal>
  );
}

